module.exports = __webpack_public_path__ + "img/rate.967d173f.png";